import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";

const FrequencyCard = (props) => {
  const { metrics } = props.optionsResults;

  return (
    <GenericCard
      title="Frequency"
      tooltipText="How often this model+symbol actually fires a buy signal, and how success rate breaks down by entry weekday -- relevant since weeklies expire Friday."
    >
      <div>
        <h5>Signals / month</h5>
        <h3>{metrics.signalsPerMonth}</h3>
      </div>
      <div className="pt-2">
        <h5>Success rate by entry weekday</h5>
        <div className="flex gap-4 flex-wrap">
          {Object.entries(metrics.dayOfWeekBreakdown).map(([day, stats]) => (
            <div key={day}>
              <h5>{day.slice(0, 3)}</h5>
              <h4>
                {stats.total ? `${stats.successRate}%` : "N/A"}{" "}
                <span className="text-xs">({stats.total})</span>
              </h4>
            </div>
          ))}
        </div>
      </div>
    </GenericCard>
  );
};

FrequencyCard.propTypes = { optionsResults: PropTypes.object };

export default FrequencyCard;
